'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

/* eslint-disable func-names */
/**
 * This component has been deprecated. Please see modal-v2 (<Modal>, <ChildModal>, <useModal>)
 * @deprecated
 */
var ModalContext = react.createContext({
    modals: [],
    addModal: function (jsx, title, isRequired) { return null; },
    addModalWithOptions: function (jsx, options) { return null; },
    removeCurrentModal: function (timeout) { return null; },
    closeAllModals: function () { return null; },
    hideOverflow: function () { return null; },
    hideScroll: function () { return null; },
    showOverflow: function () { return null; },
    overflow: '',
    isLoader: false,
    showLoader: function () { return null; },
    hideLoader: function () { return null; }
});
var ModalContext$1 = ModalContext;

exports.default = ModalContext$1;
//# sourceMappingURL=ModalContext.js.map
